<template>
  <div>
    <div class="mb-4">
      <FilterTabs
        label="View by"
        v-model="selectedTab"
        :options="tabOptions"
        @change="onTabChange"
      />
    </div>

    <div style="height: 400px">
      <ScheduledMeeting_Table
        v-if="selectedTab === 'My Meetings'"
        :user-id="currentUserId"
      />
      <ScheduledMeeting_Table
        v-else-if="selectedTab === 'All Meetings'"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ScheduledMeeting_Table from '@/components/Lists/ScheduledMeeting_Table.vue'
import FilterTabs from '@/components/widgetcomponents/library/FilterTabs.vue'

export default {
  name: 'TabbedScheduledMeetingTable',
  components: {
    ScheduledMeeting_Table,
    FilterTabs
  },
  props: {
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const localStorageKey = this.settings?.localStorage_key || 'scheduled_meeting_tab'
    const defaultTab = this.settings?.default_tab || 'My Meetings'

    return {
      selectedTab: localStorage.getItem(localStorageKey) || defaultTab
    }
  },
  computed: {
    ...mapState({
      currentUserId: state => state.current_user?.id
    }),
    tabOptions() {
      const tabs = this.settings?.tabs || ['My Meetings', 'All Meetings']
      return tabs.map(tab => ({ value: tab, label: tab }))
    },
    localStorageKey() {
      return this.settings?.localStorage_key || 'scheduled_meeting_tab'
    }
  },
  methods: {
    onTabChange(value) {
      localStorage.setItem(this.localStorageKey, value)
    }
  }
}
</script>
